import { FooterSection } from "@/components/FooterSection/FooterSection";
import { LeadMagnetNextSteps } from "@/components/LeadMagnetNextSteps/LeadMagnetNextSteps";
import { ThankYouRedirect } from "@/components/ThankYouRedirect/ThankYouRedirect";
import { SECTION_MANIFEST, type SectionDef, type UsedComponentKey } from "./section-manifest";
import type { SectionComponent } from "./types";

// type -> component. NO schemas/zod here: section-registry.tsx imports this on
// the client, so keeping it schema-free removes zod/v4 + the section schemas
// from the client bundle. The parallel type -> schema map (validation) lives in
// sections.ts (server/build-only). Both maps are derived from the single
// manifest in section-manifest.ts (parity by construction) — see that file's
// header comment. Component VALUES are still imported per-file (not via the
// `@/components` barrel) so only the components a page can actually render
// enter the client bundle. These direct imports also validate the manifest's
// closed component-name union against the real component exports.
const COMPONENTS: Record<UsedComponentKey, SectionComponent> = {
  FooterSection,
  LeadMagnetNextSteps,
  ThankYouRedirect,
};

export const sectionRegistry: Record<string, SectionComponent> = Object.fromEntries(
  Object.entries(SECTION_MANIFEST)
    .filter((entry): entry is [string, SectionDef & { component: UsedComponentKey }] =>
      Boolean(entry[1].component),
    )
    .map(([type, def]) => [type, COMPONENTS[def.component]]),
);
